<div class="dialog">
  <div class="dialog-header">
    <h3>{{ data.settingsType === 'printPdfEmailLang'
          ? ('PRINT|Ustawienia PDF' | translate)
          : ('PRINT|Ustawienia drukowania' | translate) }}
    </h3>
    <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
        <icc-icon name="close"></icc-icon>
    </button>
  </div>
  <div class="dialog-body">
    <ng-container *ngIf="data.settingsType === 'printOrder' && data.orderPrintOptions?.length">
      <h2>{{ 'PRINT|Wybierz rodzaj wydruku' | translate }}</h2>
      <div class="print-setting">
        <icc-select
          size="small"
          [(ngModel)]="printSettings.settingsType"
          (ngModelChange)="setOrderPrintType($event)"
        >
          <option *ngFor="let option of data.orderPrintOptions" [value]="option.settingsType">{{ option.label | translate }}</option>
        </icc-select>
      </div>
    </ng-container>
    <h2>{{ 'PRINT|Wybierz język' | translate }}</h2>
    <div class="print-setting">
      <icc-select
        size="small"
        [(ngModel)]="printSettings.printLanguage"
        (ngModelChange)="setCurrentPdfLanguage($event)"
      >
        <option *ngFor="let lang of data.availableLanguages" [value]="lang.code">{{ lang.name }}</option>
      </icc-select>
    </div>
  </div>
  <div class="dialog-footer flex-vertical">
    <div class="flex-horizontal">
      <button iccButton (click)="close()">{{ 'INTERFACE|Anuluj' | translate}}</button>
      <button iccButton (click)="save()">{{ 'INTERFACE|Zapisz' | translate}}</button>
    </div>
  </div>
</div>
<div
  class="curtain"
  (click)="close()"
></div>